import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import ShopLayout from '../../components/shop/ShopLayout';
import { useAuth } from '../../context/AuthContext';
import './AuthForm.css';
import Seo from '../../components/seo/Seo';

function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const from = location.state?.from?.pathname || '/account';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password, rememberMe);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ShopLayout breadcrumbs={[{ label: 'Login' }]}>
      <Seo title="Sign In" path="/login" />
      <div className="container auth-page">
        <div className="auth-card">
          <h1>Sign In</h1>
          <p className="auth-card__subtitle">Access your orders, addresses, and account settings.</p>
          <form className="auth-form" onSubmit={handleSubmit}>
            {error && <div className="auth-form__error">{error}</div>}
            <div className="auth-form__field">
              <label htmlFor="email">Email</label>
              <input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div className="auth-form__field">
              <label htmlFor="password">Password</label>
              <input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            <label className="auth-form__checkbox">
              <input type="checkbox" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />
              Remember me
            </label>
            <button type="submit" className="auth-form__submit" disabled={loading}>
              {loading ? 'Signing in…' : 'Sign In'}
            </button>
          </form>
          <div className="auth-card__footer">
            <p><Link to="/forgot-password">Forgot password?</Link></p>
            <p>Don&apos;t have an account? <Link to="/register">Create one</Link></p>
          </div>
        </div>
      </div>
    </ShopLayout>
  );
}

export default LoginPage;
